import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

function ShippingPolicy() {
  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/#about">About</Link>
          <Link to="/#branches">Branches</Link>
          <Link to="/#services">Services</Link>
          <Link to="/#gallery">Gallery</Link>
        </nav>
      </header>

      {/* Shipping Policy Content */}
      <div className="privacy-content-page">
        <div className="container">
          <button className="close-btn" onClick={() => window.history.back()}>
            ✖
          </button>
          <h1>Shipping Policy</h1>
          <p><strong>Last Updated: November 26, 2025</strong></p>
          <p>For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only.</p>
          <p>For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only.</p>
          <p>Orders are shipped within 1-2 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.</p>
          <p>ALIVE HOSPITALITY is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 1-2 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation.</p>
          <p>Delivery of all orders will be to the address provided by the buyer.</p>
          <p>Delivery of our services will be confirmed on your mail ID as specified during registration.</p>
          <p>For any issues in utilizing our services you may contact our helpdesk on 9160610001 or airlive.app@gmail.com</p>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive Hospitality. All Rights Reserved to alive hospitality.</p>
      </footer>
    </div>
  );
}

export default ShippingPolicy;
